<template>
  <div
    class="d-flex justify-content-center"
  >
    <template v-if="isArticleSuccessful(article)">
      <b-button
        variant="secondary"
        size="sm"
        class="action-button"
        @click.left="openContentEditorPage(article)"
        @click.right="openContentEditorPageInNewTab(article)"
      >
        <i class="icon-btn fal fa-edit" />
      </b-button>
      <template v-if="isApprovalPending(article)">
        <b-button
          variant="secondary"
          size="sm"
          class="ml-2 action-button"
          @click="openActionConfirmationModal('approve')"
          :disabled="!canUpdateApprovalState"
          data-test="approve-article"
        >
          <i class="icon-btn fal fa-check" />
        </b-button>
        <b-button
          variant="secondary"
          size="sm"
          class="ml-2 action-button"
          @click="openActionConfirmationModal('disapprove')"
          :disabled="!canUpdateApprovalState"
          data-test="disapprove-article"
        >
          <i class="icon-btn fal fa-xmark" />
        </b-button>
      </template>
      <template v-else>
        <b-button
          variant="secondary"
          size="sm"
          class="ml-2 action-button"
          @click="openActionConfirmationModal(`${ isArticleActive(article) ? 'pause' : 'publish' }`)"
          :disabled="!canTogglePublishState(article.id, `${ isArticleActive(article) ? 'pause' : 'publish' }`)"
          :data-test="isArticleActive(article) ? 'pause-action-btn' : 'publish-action-btn'"
        >
          <i :class="`icon-btn fal fa-${ isArticleActive(article) ? 'pause' : 'play' }`" />
        </b-button>
        <b-button
          variant="secondary"
          size="sm"
          class="ml-2 action-button"
          @click="openScheduleArticlesModal([article.id])"
          :disabled="article.matchingHealth === 'LOW'"
        >
          <i class="icon-btn fal fa-clock" />
        </b-button>
      </template>
    </template>
    <template v-if="isArticleFailed(article)">
      <b-button
        variant="secondary"
        size="sm"
        @click.left="openContentEditorPage(article)"
        @click.right="openContentEditorPageInNewTab(article)"
        :disabled="!canManuallyInputArticle"
      >
        Manually Input
      </b-button>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import ArticlesStateMixins from '@/modules/content/components/ContentPage/mixins/ArticlesStateMixins';
import ArticlesActionsMixins from '@/modules/content/components/ContentPage/mixins/ArticlesActionsMixins';
import urlHelper from '@/core/mixins/urlHelper';

export default {
  name: 'ArticlesActions',
  mixins: [
    urlHelper,
    ArticlesStateMixins,
    ArticlesActionsMixins,
  ],
  props: {
    article: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'feedId',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_READ_ONLY,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_ARTICLE_BY_ID,
    ]),
    canManuallyInputArticle() {
      return !this.GET_IS_READ_ONLY();
    },
  },
  methods: {
    buildContentEditorRoute(article) {
      return {
        name: 'ContentEditor',
        params: {
          advertiserId: this.campaign.advertiserId,
          campaignId: this.campaign.id,
          feedId: this.feedId,
          articleId: article.id,
        },
      };
    },
    openContentEditorPage(article) {
      this.$router.push(this.buildContentEditorRoute(article));
    },
    openContentEditorPageInNewTab(article) {
      this.openURLInNewTab(this.$router.resolve(this.buildContentEditorRoute(article)).href);
    },
    canTogglePublishState(id, action) {
      if (action === 'publish') return this.canPublishArticles({ ids: [id] });
      if (action === 'pause') return this.canPauseArticles({ ids: [id] });
      return false;
    },
    openActionConfirmationModal(action) {
      const payload = {
        action,
        ids: [this.article.id],
      };
      this.$emit('openActionConfirmationModal', payload);
    },
    openScheduleArticlesModal(ids) {
      this.$emit('openScheduleArticlesModal', { ids });
    },
  },
};
</script>
<style lang="scss" scoped>
.action-button {
  display: flex;
  justify-content: center;
  align-items: center;
  .icon-btn {
    font-weight: 400;
    font-size: 1rem;
  }
}
</style>
